"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getCachedUser = ctx => {
  if (!ctx.useUser || !ctx.useApplicationPreferences) {
    return {};
  }
  const {
    locale: userLanguage,
    hp2Migrate,
    pssSurveyLastSeen,
    pssSurveyLastCompleted,
    ...user
  } = ctx.useUser();
  const application = ctx.useApplicationPreferences();
  return {
    application,
    user,
    preferences: {
      hp2Migrate,
      userLanguage,
      pssSurveyLastSeen,
      pssSurveyLastCompleted
    }
  };
};
var _default = exports.default = getCachedUser;